import { Button, Stack, Typography } from '@mui/material';
import { useTutorials } from './tutorial.hooks';
import { TutorialsList } from './components/tutorials-list';
import { ImperativeDialog } from '@shared/components/dialogs/imperative-dialog';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import {
  ONBOARDING_STEP_KEYS,
  useOnboardingGuideVisibility,
} from '@features/onboarding/guide-visibility';
import useIntl from 'react-intl/src/components/useIntl';
import { useAnalytics } from '@libs/mixpanel/useAnalytics';

export const TutorialDialog = () => {
  const intl = useIntl();
  const { t } = useIntlTranslations();
  const { tutorials, tutorialsDialogRef } = useTutorials();

  const { showGuide, isVisible: isOnboardingGuideVisible } =
    useOnboardingGuideVisibility(ONBOARDING_STEP_KEYS);
  const { trackEvent } = useAnalytics();

  return (
    <>
      <Button
        endIcon={<PlayArrowIcon fontSize="small" />}
        sx={{ background: 'white' }}
        onClick={() => {
          trackEvent('tutorial_opened', {});
          tutorialsDialogRef.current?.open();
        }}
      >
        {t('tutorials.title')}
      </Button>
      <ImperativeDialog
        ref={tutorialsDialogRef}
        dialogHelperText="V případě nejasností se na nás obraťte vpravo nahoře na live chatu."
        title={t('tutorials.dialogTitle')}
        contentStackProps={{ rowGap: 1.5 }}
      >
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            {intl.formatMessage({
              id: 'tutorials.interactiveGuideDescription',
              defaultMessage:
                'Interaktivní průvodce na dashboardu vám pomůže projít první důležité kroky v aplikaci.',
            })}
          </Typography>
          <Button
            variant={isOnboardingGuideVisible ? 'outlined' : 'contained'}
            onClick={() => {
              showGuide();
              tutorialsDialogRef.current?.close();
            }}
          >
            {intl.formatMessage({
              id: 'tutorials.openInteractiveGuide',
              defaultMessage: 'Otevřít interaktivního průvodce',
            })}
          </Button>
        </Stack>
        <TutorialsList tours={tutorials} />
      </ImperativeDialog>
    </>
  );
};
